import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import { initializeSentry, Sentry } from './sentry'
import { ThemeProvider } from './theme'

initializeSentry()

window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason);
});
window.addEventListener('error', (event) => {
  Sentry.captureException(event.error ?? new Error(event.message));
});

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </ThemeProvider>
);
